import type { ThunkDependencies } from "single-spa/store/thunk-dependencies";
import type { ThunkDispatchCommon, ThunkGetState } from "single-spa/store/types";
import { managementActions } from "../../store/action-creators";

export const getSfMappingFieldsThunk =
    () => async (dispatch: ThunkDispatchCommon, _getState: ThunkGetState, deps: ThunkDependencies) => {
        try {
            dispatch(managementActions.salesforce.getMappingFieldsAsync.request());

            const response = await deps.si.api.management.getSfMappingFields();
            dispatch(managementActions.salesforce.getMappingFieldsAsync.success(response));
        } catch (error) {
            dispatch(managementActions.salesforce.getMappingFieldsAsync.failure(error));
        }
    };

export const putSfStatusFieldThunk =
    (externalField: string) =>
    async (dispatch: ThunkDispatchCommon, _getState: ThunkGetState, deps: ThunkDependencies) => {
        try {
            dispatch(managementActions.salesforce.putStatusFieldAsync.request());

            const { value } = await deps.si.api.management.putSfStatusField(externalField);

            if (value) {
                await dispatch(getSfMappingFieldsThunk());
                dispatch(managementActions.salesforce.putStatusFieldAsync.success());
            } else {
                dispatch(managementActions.salesforce.putStatusFieldAsync.failure("Can't update SF status"));
            }
        } catch (error) {
            dispatch(managementActions.salesforce.putStatusFieldAsync.failure(error));
        }
    };

export const putSfFilterFieldsThunk =
    (fields: string[]) => async (dispatch: ThunkDispatchCommon, _getState: ThunkGetState, deps: ThunkDependencies) => {
        try {
            dispatch(managementActions.salesforce.putFilterFieldsAsync.request());
            const { value } = await deps.si.api.management.putSfFilterFields(fields);
            if (value) {
                await dispatch(getSfMappingFieldsThunk());
                dispatch(managementActions.salesforce.putFilterFieldsAsync.success(value));
            }
            return value;
        } catch (error) {
            dispatch(managementActions.salesforce.putFilterFieldsAsync.failure(error));
            return false;
        }
    };
